var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5.7 12.3H3a2 2 0 0 1-2-2V3c0-1.1.9-2 2-2h7.3a2 2 0 0 1 2 2v2.7",
    vectorEffect: "non-scaling-stroke"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.3,
    height: 11.3,
    x: 5.71,
    y: 5.71,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2,
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgCopy;